export const months = [6, 12, 24];
